// Clever login failures redirect to a sign-in page with ?error=clever_*. Several codes share a
// message on purpose — they stay distinct in logs — and anything unmapped falls back to the
// generic failure.
const CLEVER_ERROR_MESSAGE_IDS: Record<string, string> = {
  clever_district_not_linked: 'auth.clever.district-not-linked',
  clever_user_not_found: 'auth.clever.no-account',
  clever_student_profile_missing: 'auth.clever.no-account',
  clever_auth_user_missing: 'auth.clever.no-account',
};

/** The label id to show for an `error` query param, or null when it is not a Clever error. */
export const getCleverErrorMessageId = (error: string | null | undefined): string | null => {
  if (!error?.startsWith('clever_')) return null;
  return CLEVER_ERROR_MESSAGE_IDS[error] ?? 'auth.clever.sign-in-failed';
};
